import { Movimentation } from './movimentation';
export class Investment {
	number: number;
	code: number;
	description: string;
	applicationDate: string;
	dueDate: string;
	rentability: string;
	applicationValue: number;
	currentValue: number;
	rescueValue: number;
	percent: number;
	currentBalanceInvestValue: number;
	movimentationList: Array<Movimentation> = [];

	constructor() {}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/investments/investments-extract/models/investment.ts